module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copyt"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iv",
      "title": "iv"
    }
  }, [_vm._v("This book is a publication of")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Indiana University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Office of Scholarly Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Herman B Wells Library 350")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1320 East 10th Street")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Bloomington, Indiana 47405 USA")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "href": "http://iupress.indiana.edu",
      "target": "_blank"
    }
  }, [_vm._v("iupress.indiana.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("© 2020 by Richard Abel")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("No part of this book may be reproduced or utilized in any form or by any means, electronic or mechanical, including photocopying and recording, or by any information storage and retrieval system, without permission in writing from the publisher. The paper used in this publication meets the minimum requirements of the American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, ANSI Z39.48-1992.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Names: Abel, Richard, 1941- author.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Title: Motor City movie culture, 1916-1925 / Richard Abel.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Description: Bloomington, Indiana : Indiana University Press, [2020] | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Identifiers: LCCN 2019036664 (print) | LCCN 2019036665 (ebook) | ISBN 9780253046451 (hardback) | ISBN 9780253046468 (paperback) | ISBN 9780253046499 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Subjects: LCSH: Motion picture theaters—Michigan—Detroit—History—20th century. | Motion picture audiences—Michigan—Detroit—History—20th century. | Motion pictures—Social aspects—Michigan—Detroit.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Classification: LCC PN1993.5.U752 A24 2020 (print) | LCC PN1993.5.U752 (ebook) | DDC 384.850977434—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2019036664",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019036664")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("LC ebook record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2019036665",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019036665")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("1 2 3 4 5    25 24 23 22 21 20")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fae57642","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/00a_fm0.vue
// module id = 66
// module chunks = 0